<template>
	<transition name="fade">
		<div v-if="show">
			<div v-if="overlay" class="overlay">
			</div>
		</div>
	</transition>
</template>

<style lang="scss" scoped>
	.overlay {
		position: absolute;
		background: #fff;
		opacity: 0.8;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		z-index: 2;
	}
</style>

<script>
	import bus from '@/bus/event-bus.js'
	export default {
		props: {
			overlay: {
				default: true
			}
		},
		data() {
			return {
				show: false
			}
		},
		mounted() {
			bus.$on('loading', (l) => {
				this.show = l;
			})
		}
	}
</script>


// WEBPACK FOOTER //
// src/components/ui/Loader.vue